import React from 'react';
import makeClass from 'clsx';
import { useTheme } from '@design-systems/theme';
import { B3 } from '@ids-ts/typography';
import "@ids-ts/typography/dist/main.css";
import { checkForA11yProps } from '@ids-ts/utils';
import styles from './Bar.css';
/** A progress indicator rendered as a circle */
const Bar = function (props) {
  const ariaLabel = props['aria-label'],
    className = props.className,
    colorScheme = props.colorScheme,
    doesLoop = props.doesLoop,
    doesPersist = props.doesPersist,
    isMultiple = props.isMultiple,
    label = props.label,
    theme = props.theme,
    value = props.value;
  checkForA11yProps('Loader', props, ['label', 'aria-label']);
  const _useTheme = useTheme({
      theme,
      colorScheme
    }, styles),
    themeClass = _useTheme.themeClass;
  return /*#__PURE__*/React.createElement("div", {
    className: makeClass(styles.wrapper, themeClass, className, {
      [styles.multi]: isMultiple
    }),
    role: "progressbar",
    "aria-valuenow": value,
    "aria-valuemin": 0,
    "aria-valuemax": 100,
    "aria-live": "polite",
    "aria-label": ariaLabel || label
  }, label && /*#__PURE__*/React.createElement(B3, {
    className: styles.label
  }, label), /*#__PURE__*/React.createElement("div", {
    className: styles.bar
  }, value ? /*#__PURE__*/React.createElement("div", {
    className: makeClass(styles.progress, {
      [styles.complete]: value >= 100,
      [styles.persists]: doesPersist
    }),
    style: {
      width: `${value}%`
    }
  }) : /*#__PURE__*/React.createElement("div", {
    className: makeClass(styles.progress, themeClass, className, {
      [styles.loops]: doesLoop
    }),
    style: {
      width: `${value}%`
    }
  })));
};
export default Bar;
//# sourceMappingURL=Bar.js.map